import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import Hamburger from '../../assets/icons/hamburger';
import BackToHomePageButton from '../back-to-home-page-button';
import Sections from './sections';
import { Box, CloseSide, OpenSide, SideContainer } from './styles';
import './styles.scss';

import appInfo from '../../data/appInfo';
import SubjectButtons from '../subject-buttons';
import { useSubjectsContext } from '../../contexts/SubjectsContext';

interface SideBarProps {
  sidebar: boolean;
  setSidebar: React.Dispatch<React.SetStateAction<boolean>>;
}

function SideBar({ sidebar, setSidebar }: SideBarProps) {
  const subjects = useSubjectsContext();
  const BREAKPOINT = 835;

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isChildSubjectOpen, setChildSubjectOpen] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState('apresentacao');

  useEffect(() => {
    window.addEventListener('resize', () => setWindowWidth(window.innerWidth));
    return () => {
      window.removeEventListener('resize', () => setWindowWidth(window.innerWidth));
    };
  }, []);

  useEffect(() => {
    const selectedSubjectObject = subjects.filter((subject) => subject.slug === selectedSubject)[0];

    if (selectedSubjectObject
        && selectedSubjectObject.children
        && selectedSubjectObject.children.length > 0) {
      setChildSubjectOpen(true);
    } else {
      setChildSubjectOpen(false);
    }
  }, [selectedSubject]);

  const openSidebar = (event: React.MouseEvent) => {
    event.preventDefault();
    setSidebar(true);
  };

  const closeSidebar = (event: React.MouseEvent) => {
    event.preventDefault();
    setSidebar(false);
  };

  return (
    <>
      {!sidebar && (
        <div className="wrap-icon">
          <OpenSide
            className="openSide"
            $isopen={sidebar}
            onClick={(event) => openSidebar(event)}
          >
            <Hamburger />
          </OpenSide>
        </div>
      )}

      <SideContainer
        $isopen={sidebar}
        className={sidebar ? 'nav-menu active' : 'nav-menu'}
      >
        <CloseSide>
          {appInfo.initialScreen === 'default' && <BackToHomePageButton />}
          <CloseIcon onClick={(event) => closeSidebar(event)} />
        </CloseSide>

        <Box>
          {
            subjects.map((subject) => (
              <SubjectButtons
                key={subject.slug}
                subject={subject}
                selectedSubject={selectedSubject}
                setSelectedSubject={setSelectedSubject}
                onClick={() => {
                  if (windowWidth <= BREAKPOINT) setSidebar(false);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              />
            ))
          }
        </Box>
      </SideContainer>
    </>
  );
}

export default SideBar;
